module.exports = __webpack_public_path__ + "static/Cafe24Danjunghae.subset-37999702a6d10967de625faa3dfb906f.otf";